﻿import Tabby from 'tabbyjs';

export function initTabby(selector) {
  new Tabby(selector);
}